module.exports = __webpack_public_path__ + "img/4_169.e3961eea.png";